import React from 'react';
import '../../styles/_Portfolio.css';
import { Grid, Row, Col } from "react-bootstrap";
import SideBar from '../SideBar';
import MenuPOR from "./Menu_port";
import Projects from './Projects';
import { connect } from 'redux-zero/react';

/*const Info = ({ isSpanish }) => {
    return (
        <Col className='info__portfolio'>
            {isSpanish === true ? <h4>Miremos algunos trabajos</h4> :
                <h4>Let's check some of my work</h4>}
        </Col>
    )
}*/

const ProjectsContainer = ({bio, isSpanish}) => {
    return (
        <Col lg={9} md={9} id='portfolio__container'>
            <MenuPOR isSpanish={isSpanish} />
            {/*<Info />*/}
            <Projects bio={bio} isSpanish={isSpanish} />
        </Col>
    )
}

const PortfolioView = ({bio , isSpanish}) => {
    return (
        <Grid fluid>
            <Row>
                <SideBar />
                <ProjectsContainer bio={bio} isSpanish={isSpanish} />
            </Row>
        </Grid>
    )
}

//export default PortfolioView;
const mapToProps = ({ bio, isSpanish }) => ({ bio, isSpanish });
export default connect(mapToProps)(PortfolioView);


// WEBPACK FOOTER //
// ./src/components/Portfolio/Portfolio.js